import React, { useEffect, useState } from "react";
import "./accessibility.css";

export default function AccessibilityTools({ open, onClose }) {
  const [fontSize, setFontSize] = useState(100); // default 100%

  useEffect(() => {
    if (open) {
      document.body.classList.add("accessibility-open");
    } else {
      document.body.classList.remove("accessibility-open");
    }
  }, [open]);

  // Update body font size whenever fontSize changes
  useEffect(() => {
    document.body.style.fontSize = `${fontSize}%`;
  }, [fontSize]);

  const increaseFont = () => {
    if (fontSize < 200) setFontSize(fontSize + 10);
  };

  const decreaseFont = () => {
    if (fontSize > 50) setFontSize(fontSize - 10);
  };

  const resetFont = () => setFontSize(100);

  // Toggle features like dark mode, high contrast, etc.
  const toggleFeature = (e, className) => {
    document.body.classList.toggle(className);
    e.currentTarget.classList.toggle("active");
  };

  return (
    <div className={`access-panel ${open ? "show" : ""}`}>
      <div className="access-header">
        <span>Accessibility Tools</span>
        <button className="close-btn" onClick={onClose}>✕</button>
      </div>

      {/* TEXT SIZE */}
      <section>
        <h6>Text Size</h6>
        <div className="grid">
          <button onClick={increaseFont}>A+</button>
          <button onClick={resetFont}>A</button>
          <button onClick={decreaseFont}>A-</button>
        </div>
      </section>

      {/* COLOR MODES */}
      <section>
        <h6>Color Adjustment</h6>
        <div className="grid">
          <button onClick={(e) => toggleFeature(e, "high-contrast")}>High Contrast</button>
          <button onClick={(e) => toggleFeature(e, "dark-mode")}>Dark Mode</button>
          <button onClick={(e) => toggleFeature(e, "highlight-links")}>Highlight Links</button>
        </div>
      </section>

      {/* TEXT LAYOUT */}
      <section>
        <h6>Text Layout</h6>
        <div className="grid">
          <button onClick={(e) => toggleFeature(e, "line-height")}>Line Height</button>
          <button onClick={(e) => toggleFeature(e, "text-spacing")}>Text Spacing</button>
        </div>
      </section>

      {/* NAVIGATION */}
      <section>
        <h6>Navigation</h6>
        <div className="grid">
          <button onClick={(e) => toggleFeature(e, "big-cursor")}>Big Cursor</button>
          <button onClick={(e) => toggleFeature(e, "hide-images")}>Hide Images</button>
        </div>
      </section>
    </div>
  );
}
